import {useEffect, useRef} from 'react';
import {BulletinHoursListIdsRequest} from '../../../infrastructure/remote/sacmi/dto/request/BulletinHoursListIdsRequest';

const findBySuffix = (filters: Record<string, string>, suffix: string): string | null => {
    const key = Object.keys(filters).find(k => k.endsWith(suffix));
    return key ? filters[key] || null : null;
};

const extractCriteria = (parsedFilters: Record<string, string>): BulletinHoursListIdsRequest => ({
    criteria: {
        start_date: findBySuffix(parsedFilters, '.date__from'),
        end_date: findBySuffix(parsedFilters, '.date__to'),
        bulletin_id: parsedFilters['bulletin'] ? parseInt(parsedFilters['bulletin'], 10) : null,
        user_id: parsedFilters['technician'] ? parseInt(parsedFilters['technician'], 10) : null,
        client_id: parsedFilters['client'] ? parseInt(parsedFilters['client'], 10) : null,
        term: parsedFilters['term'] || null,
    }
});

export const useSummaryListFilters = () => {
    const summaryListFiltersRef = useRef<BulletinHoursListIdsRequest>({criteria: {}});

    useEffect(() => {
        const originalFetch = window.fetch;

        window.fetch = function (input: RequestInfo | URL, init?: RequestInit) {
            const url = typeof input === 'string' ? input : input instanceof URL ? input.toString() : input.url;
            if (url.includes('summary/list/extended') && init?.body) {
                try {
                    const parsed = typeof init.body === 'string' ? JSON.parse(init.body) : null;
                    if (parsed?.filters) {
                        summaryListFiltersRef.current = extractCriteria(parsed.filters);
                    }
                } catch (_) {}
            }
            return originalFetch.apply(this, [input, init] as any);
        };

        return () => {
            window.fetch = originalFetch;
        };
    }, []);

    return summaryListFiltersRef;
};
